define('BluePoint.LanguageSwitcher.LanguageSwitcher', 
	[
		'BluePoint.LanguageSwitcher.LanguageSwitcher.View'
	],
	function (LanguageSwitcherView) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var environment = container.getComponent("Environment");
				var layout = container.getComponent("Layout");
				var isactive = environment.getConfig('languageswitcher.isactive');

				if (isactive && layout) {
					var languageArray = [];
					layout.on('beforeShowContent', function () {
						languageArray = environment.getSiteSetting('languages');
						console.log("languageArray", languageArray);
					});

					layout.addChildView('Header.LanguageSelector', function () {
						return new LanguageSwitcherView({ 
							container: container,
							environment: environment,
							languageArray: languageArray
						});
					});

					// layout.addToViewContextDefinition('Header.View', 'showLanguageSelector', 'boolean', function (context) {
					// 	return (languageArray && languageArray.length > 1) ? true : false;
					// });
				}

			}
		};
	});
